"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description 坐标轴组件的主题样式
 */
var const_1 = require("../const");
exports.default = {
    title: {
        textStyle: {
            fontSize: 12,
            fill: '#595959',
            textBaseline: 'middle',
            fontFamily: const_1.FONT_FAMILY,
            textAlign: 'center',
        },
        offset: 20,
    },
    label: {
        textStyle: {
            fontSize: 12,
            fill: '#ccc',
            textBaseline: 'middle',
            fontFamily: const_1.FONT_FAMILY,
        },
        offset: 10,
        offsetX: 0,
        offsetY: 0,
    },
    grid: {
        lineWidth: 1,
        stroke: '#C0D0E0',
    },
};
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/axis/theme.js
// module id = 771
// module chunks = 37